var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.mobile)?_c('Nav'):_vm._e(),(_vm.mobile)?_c('NavMobile'):_vm._e(),_c('router-view'),(!_vm.mobile)?_c('Footer',{staticStyle:{"min-width":"1280px"}}):_vm._e(),(_vm.mobile)?_c('FooterMobile'):_vm._e(),(!_vm.mobile)?_c('Suspension'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }